module.exports = __webpack_public_path__ + "static/img/hpten.7e1b4ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hpten.png
// module id = scMI
// module chunks = 7